<template>
  <div id="Footer">
    <div class="logo">
      <img src="../../assets/icons/KwanzaaFresh-Logo_White.svg" />
    </div>
    <nav>
      <ul>
        <li  @click="scrollTo('nav')"><router-link to="/about">About</router-link></li>
        <li  @click="scrollTo('nav')"><router-link to="/contact">Contact</router-link></li>
        <li><a href="">Cancellation Policy</a></li>
        <li><a href="">Terms and Conditions </a></li>
      </ul>
    </nav>
    <!-- <div class="subscription">
      <p>Get the latest news from us:</p>
      <div class="Subbutton">
        <input type="text" placeholder="Email">
        <button>Subscribe</button>
      </div>
    </div> -->
    <div class="socialMedia">
      <ul>
        <li><a href="https://www.facebook.com/kwanzaamilk" target="_blank"><img src="../../assets/icons/facebook.png"></a></li>
        <li><a href="https://www.instagram.com/kwanzaamilk" target="_blank"><img src="../../assets/icons/instagram.png"></a></li>
        <li><a href="https://twitter.com/kwanzaamilk" target="_blank"><img src="../../assets/icons/twitter.png"></a></li>
      </ul>
    </div>
      <p>{{ copyrightMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      copyrightMessage:
        "© Kwanzaa Fresh, " + this.getYear(),
    };
  },
  methods: {
    getYear() {
      var date = new Date();
      var year = date.getFullYear();
      return year;
    },
     scrollTo(id) {
      const element = document.getElementById(id);
      element.scrollIntoView({ behavior: "smooth" });
    },
    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },
};
</script>

<style scoped>

#Footer {
  color: #fff;
   padding: 50px 0px 50px 0px;
  background-color: #06d6a0;
}
input, button{
  border: none;
  margin: 5px;
}
.Subbutton{
  display: flex;
  justify-content: center;
}
input{
  padding-left: 10px;
  color: #000;
  height: 40px;
  width: 286px;
  border-radius: 30px;
  background-color: #FFF;
}
 p{
   margin-top: 30px;
  text-align: center;
  font-family: "DM Sans";
  font-size: 16px;
  line-height: 21px;
}
button{
  height: 40px;
  width: 125px;
  color: #FFF;
  font-family: "DM Sans";
  font-size: 16px;
  line-height: 21px;
  text-align: center;
  border-radius: 30px;
  background-color: #0077B6;
}
ul {
  display: flex;
  justify-content: center;
  padding: unset;
}
li {
  list-style: none;
}
.socialMedia {
  margin-top: 30px;
}
#nav a {
  text-decoration: none;
  color: #fff;
  margin: 0px 20px 0px 20px;
}
.logo {
  display: grid;
  place-items: center;
  margin-bottom: 50px;
}
.logo img {
  margin: auto;
  /* height: 64.31px; */
  width: 200px;
}
@media screen and (max-width:720px){
  nav ul {
  display: grid;
  place-items: center;
}
li {
  margin: 10px;
}
}
</style>